require('./edge.service')
require('./edge.service.deprecated')
require('./broadcastView.service')
require('./edgeGroup.service.deprecated')
require('./edgeGroup.service')
require('./organization.service')
require('./user.service')
require('./nominatimLookUp.service')
require('./geofence.service')
require('./preventTemplateCache.service')
require('./unitSystem')
require('./devices.service')
require('./configuration.service')
require('./notifications.service')
